import Slider from 'react-slick';
import s from './UpsellModal.module.scss';

type imageType = {
  ID: string;
  alt: string;
  url: string;
};

const swiperSettings = {
  focusOnSelect: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  speed: 500,
  className: s.productGallery__innerDiv,
  variableWidth: true,
  dots: false,
  adaptiveHeight: true,
  rows: 1,
  nextArrow: <></>,
  prevArrow: <></>,
  arrows: false,
};

const SwiperGallery = ({ gallery }: { gallery: imageType[] }) => {
  return (
    <div className={s.productGallery}>
      <Slider {...swiperSettings}>
        {gallery.map((item) => (
          <div className={s.productGallery__item} key={item.ID}>
            <img src={item.url} alt={item.alt} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SwiperGallery;
